
import { User, UserRole } from '../types';

const BASE_URL = 'https://api.coinnexs.com/api/auth';

export interface AuthResponse<T = any> {
    success: boolean;
    message: string;
    data?: T;
    token?: string;
    user?: User & { id: string };
}

class AuthService {
    private async request<T>(endpoint: string, options: RequestInit): Promise<AuthResponse<T>> {
        const token = localStorage.getItem('coinnexs_token');
        const headers = {
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
            ...options.headers,
        };

        try {
            const response = await fetch(`${BASE_URL}${endpoint}`, {
                ...options,
                headers,
            });

            const data = await response.json();
            return data;
        } catch (error) {
            console.error(`API Error (${endpoint}):`, error);
            return {
                success: false,
                message: 'Network error. Please try again later.',
            };
        }
    }

    async register(payload: any) {
        return this.request('/register', {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    }

    async login(payload: any) {
        return this.request('/login', {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    }

    async forgotPassword(email: string) {
        return this.request('/forgot-password', {
            method: 'POST',
            body: JSON.stringify({ email }),
        });
    }

    async resetPassword(payload: any) {
        return this.request('/reset-password', {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    }

    async changePassword(payload: any) {
        return this.request('/change-password', {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    }

    async logout() {
        return this.request('/logout', {
            method: 'POST',
        });
    }
}

export const authService = new AuthService();
